import { render, staticRenderFns } from "./game-info.vue?vue&type=template&id=3aa6bdf1&lang=pug"
import script from "./game-info.vue?vue&type=script&lang=js"
export * from "./game-info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports